import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../fundamentals/text-styles/constants.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

export const GlobalSearchTabHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const TitleText = styled.span`
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;
  /* 500 (medium)/500-R */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
  font-style: normal;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.2px;
`

export const HighlightedText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
`

export const SecondaryTextContainer = styled.span`
  color: ${colorsOptions.greys['grey-70']};
  font-variant-numeric: lining-nums proportional-nums;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* número de linhas antes do ellipsis */
  overflow: hidden;
  text-overflow: ellipsis;
  /* 500 (medium)/500-S */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  font-style: normal;
  font-weight: 500;
  line-height: 15.6px; /* 130% */
  letter-spacing: 0.2px;
`

export const TabListTitle = styled.div`
  display: flex;
  height: 47px;
  padding: 0.5rem 1rem;
  align-items: center;
  align-self: stretch;

  color: ${colorsOptions.greys['grey-70']};
  font-variant-numeric: lining-nums proportional-nums;

  /* Section header */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  font-style: normal;
  font-weight: 600;
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.4px;
  text-transform: uppercase;
`
